<template>
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect
x="4" y="10" width="32" height="28" fill="none"
stroke="currentColor" stroke-width="4" stroke-linejoin="round"
/><path
fill-rule="evenodd" clip-rule="evenodd" d="M44 14L36 20.75V27.25L44 34V14Z" stroke="currentColor" stroke-width="4"
stroke-linecap="round" stroke-linejoin="round"
/><path d="M17 19L23 24L17 29" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" /></svg>
</template>